export class TotemButtonStruct{
    public idTotemButton: number | null = null;
    public idTotem: number | null = null;
    public idCareLinePriority: number | null = null;
    
    public totemButtonName: string = '';
    public initials: string = '';
    public priorityInitials: string = '';
    public totemName: string = '';
    
    public isScheduleToggle: boolean = false;
}